import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    offers: [],
    offersCount: 0,
    offer_lines: [],
    offerLinesCount: 0,
    offer: {},
    offer_line: {},
    newOfferCode: 0,
    offerSave: {
      message: null,
      status: null,
      id: null,
    },
    offerLineSave: {
      message: null,
      status: null,
      id: null,
    },
    offerRevisedId: null,
    lineRemoveStatus: null,
  },
  getters: {
    getOffers(state) {
      return state.offers
    },
    getOffersCount(state) {
      return state.offersCount
    },
    getOfferLines(state) {
      return state.offer_lines
    },
    getOfferLine(state) {
      return state.offer_line
    },
    getOfferLinesCount(state) {
      return state.offerLinesCount
    },
    getOffer(state) {
      return state.offer
    },
    getNewOfferCode(state) {
      return state.newOfferCode
    },
    getOfferSaveStatus(state) {
      return state.offerSave
    },
    getOfferLineSaveStatus(state) {
      return state.offerLineSave
    },
    getOfferRevisedId(state) {
      return state.offerRevisedId
    },
    getOfferLineRemoveStatus(state) {
      return state.lineRemoveStatus
    },
  },
  mutations: {
    OFFERS_LIST(state, data) {
      state.offers = data
    },
    OFFER_VIEW(state, data) {
      state.offer = data
    },
    OFFERS_COUNT(state, data) {
      state.offersCount = data
    },
    OFFER_LINES_LIST(state, data) {
      state.offer_lines = data
    },
    OFFER_LINE_VIEW(state, data) {
      state.offer_line = data
    },
    OFFER_LINES_COUNT(state, data) {
      state.offerLinesCount = data
    },
    OFFERS_NONUM(state, data) {
      state.newOfferCode = data
    },
    OFFER_SAVE(state, data) {
      state.offerSave = data
    },
    OFFER_LINE_SAVE(state, data) {
      state.offerLineSave = data
    },
    OFFER_REVISED_ID(state, data) {
      state.offerRevisedId = data
    },
    OFFER_LINE_REMOVE_STATUS(state, data) {
      state.lineRemoveStatus = data
    },
  },
  actions: {
    offersList({ commit }, params) {
      const data = JSON.stringify(params)
      axiosIns
        .post('/offers', data)
        .then(response => {
          commit('OFFERS_LIST', response.data.data)
          commit('OFFERS_COUNT', response.data.count)
          commit('OFFER_SAVE', {
            message: null,
            status: null,
            id: null,
          })
        })
        .catch(error => console.error(error))
    },
    offerLinesList({ commit }, params) {
      const data = JSON.stringify(params)
      axiosIns
        .post('/offers/getLines', data)
        .then(response => {
          commit('OFFER_LINES_LIST', response.data.data)
          commit('OFFER_LINES_COUNT', response.data.count)
          commit('OFFER_SAVE', {
            message: null,
            status: null,
            id: null,
          })
        })
        .catch(error => console.error(error))
    },
    offerView({ commit }, id) {
      const data = JSON.stringify({
        where: {
          'offers.id': id,
        },
        array: false,
      })
      axiosIns
        .post('/offers', data)
        .then(response => {
          commit('OFFER_VIEW', response.data.data)
          commit('OFFER_SAVE', {
            message: null,
            status: null,
            id: null,
          })
        })
        .catch(error => console.error(error))
    },
    offerLineView({ commit }, id) {
      const data = JSON.stringify({
        where: {
          'offer_lines.id': id,
        },
        array: false,
      })
      axiosIns
        .post('/offers/getLines', data)
        .then(response => {
          commit('OFFER_LINE_VIEW', response.data.data)
          commit('OFFER_SAVE', {
            message: null,
            status: null,
            id: null,
          })
        })
        .catch(error => console.error(error))
    },
    newOfferCode({ commit }) {
      axiosIns
        .post('/offers/getNewOfferCode')
        .then(response => {
          commit('OFFERS_NONUM', response.data.code)
        })
        .catch(error => console.error(error))
    },
    offerSave({ commit }, postData) {
      const data = JSON.stringify({ formData: postData })
      axiosIns
        .post('/offers/saveData', data)
        .then(response => {
          commit('OFFER_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
    offerLineSave({ commit }, postData) {
      const data = JSON.stringify({ formData: postData })
      axiosIns
        .post('/offers/saveLineData', data)
        .then(response => {
          commit('OFFER_LINE_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
    offerRevised({ commit }, id) {
      const data = JSON.stringify({
        id_offers: id,
      })
      return axiosIns
        .post('/offers/createRevised', data)
        .then(response => {
          commit('OFFER_REVISED_ID', response.data.id)
          return response.data.id
        })
        .catch(error => console.error(error))
    },
    offerLineRemove({ commit }, id) {
      const data = JSON.stringify({
        id,
      })
      axiosIns
        .post('/offers/removeLine', data)
        .then(response => {
          commit('OFFER_LINE_REMOVE_STATUS', response.data.status)
        })
        .catch(error => console.error(error))
    },
    offerRemove({ commit }, id) {
      const data = JSON.stringify({
        id,
      })
      axiosIns
        .post('/offers/deleteData', data)
        .then(response => {
          commit('OFFER_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
  },
}
